import { Box, Typography } from "@mui/material";
import { ArrowUpLeft, Plus } from "lucide-mui";
import { styledComponent } from "../utils/styled";

const PillRoot = styledComponent(Box)(({ isDark }) => ({
  display: "flex",
  alignItems: "center",
  gap: "2px",
  padding: "8px",
  borderRadius: "6px",
  backgroundColor: isDark ? "#4379B4" : "#CCE5FE",
}));

const PillText = styledComponent(Typography)(({ isDark }) => ({
  fontSize: "12px",
  fontWeight: 400,
  fontFamily: "Inter",
  color: isDark ? "#fff" : "#434950",
  whiteSpace: "nowrap",
}));

const pillIconSx = isDark => ({
  fontSize: 16,
  color: isDark ? "#fff" : "#434950",
});

export default function DragTargetHintPill({ isDark, variant, label }) {
  const Icon = variant === "add" ? Plus : ArrowUpLeft;

  return (
    <PillRoot isDark={isDark}>
      <Icon sx={pillIconSx(isDark)} />
      <PillText isDark={isDark}>{label}</PillText>
    </PillRoot>
  );
}
